function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  filter: "url(#Checked_svg__filter0_d)"
}, React.createElement("rect", {
  x: 2,
  y: 1,
  width: 16,
  height: 16,
  rx: 4,
  fill: "url(#Checked_svg__paint0_linear)"
}), React.createElement("rect", {
  x: 2.5,
  y: 1.5,
  width: 15,
  height: 15,
  rx: 3.5,
  stroke: "#000",
  strokeOpacity: 0.051
}));

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.59 3.93a.908.908 0 00-.104.117L8.33 12.221l-2.328-3c-.303-.403-.9-.502-1.335-.221a.877.877 0 00-.208 1.284l2.687 3.477c.457.607 1.358.755 2.012.33.138-.09.259-.201.356-.33l6.515-8.65a.876.876 0 00-.082-1.187 1.013 1.013 0 00-1.356.006z",
  fill: "#fff"
});

var _ref3 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "Checked_svg__paint0_linear",
  x1: 2,
  y1: 1,
  x2: 2,
  y2: 17,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#4DB1FD"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#148CFC"
})), React.createElement("filter", {
  id: "Checked_svg__filter0_d",
  x: 0,
  y: 0,
  width: 20,
  height: 20,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), React.createElement("feOffset", {
  dy: 1
}), React.createElement("feGaussianBlur", {
  stdDeviation: 1
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.0784314 0 0 0 0 0.54902 0 0 0 0 0.988235 0 0 0 0.501038 0"
}), React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})));

var SvgChecked = function SvgChecked(props) {
  return React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none"
  }, props), _ref, _ref2, _ref3);
};

export default SvgChecked;